import { asyncScheduler, distinctUntilChanged, map, Observable, observeOn, shareReplay, startWith } from 'rxjs';
import { toNum } from '@shared/helpers/math.helper';
import { MemoizedSelector, Store } from '@ngrx/store';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { DatiIdentificativiFormService } from '../../../dati-identificativi/dati-identificativi-form.service';
import { FormGroup } from '@angular/forms';
import { getControl } from '@shared/helpers/form.helper';

export const manageSchedaDisabled = (store: Store<Revisione53State>, selectTarget: MemoizedSelector<Revisione53State, string | boolean | number>): Observable<boolean> => {
    return store.select(selectTarget).pipe(
        startWith(false),
        map((v) => {
            return toNum(v) === 0;
        }),
        distinctUntilChanged(),
        observeOn(asyncScheduler),
        shareReplay({ bufferSize: 1, refCount: true })
    );
};

export const manageScObbl = (datiIndentificativiService: DatiIdentificativiFormService, schedaForm: FormGroup, path: string): void => {
    getControl(datiIndentificativiService.form, path).valueChanges.subscribe((res) => {
        getControl(schedaForm, path).patchValue(res);
    });
};
